import { v4 as uuidv4 } from "uuid";
import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class VendorSignerResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.customerSignerId = null;
        this.customerId = null;
        this.__id = this.customerSignerId || uuidv4();
        this.name = "";
        this.firstName = "";
        this.lastName = "";
        this.birthDate = "";
        this.ssn = "";
        this.role = "";
        this.phone = "";
        this.email = "";
        this.ssnAddedByInternal = false;
        this.isVendorSigner = true;
        this.mustSign = false;
        this.validToDate = "";
        this.salepersonId = null;
        this.isActive = true;
    }
    pk() {
        return `${this.customerSignerId || this.__id}`;
    }
    static activate() {
        const urlRoot = this.urlRoot;
        return this.detail().extend({
            method: "POST",
            url: (params) => `${urlRoot}activate/${params.customerSignerId}`
        });
    }
    static deactivate() {
        const urlRoot = this.urlRoot;
        return this.detail().extend({
            method: "POST",
            url: (params) => `${urlRoot}deactivate/${params.customerSignerId}`
        });
    }
}
VendorSignerResource.urlRoot = apiResourceUrl("signers/vendor/");
//# sourceMappingURL=VendorSignerResource.js.map